import React from 'react'
import Drawer from 'material-ui/Drawer'
import MenuItem from 'material-ui/MenuItem'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { edit_profile_path, root_path, contact_path } from '../../../routes'
import { logout } from '../../../actions'


const styles={
  noUnderline:{
    textDecoration: 'none',
  },
}

class LeftSidebar extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      sidebarOpen: false,
    }
  }

  handleToggleSidebar = () => {
    this.props.toggleSidebar()
  }
  handleLogout = () => {
    this.props.toggleSidebar()
    this.props.logout()
  }
  render() {
    return (
      <Drawer
        open={this.props.sidebarOpen}
        docked={false}
        onRequestChange={this.props.toggleSidebar}
      >
        <Link style={styles.noUnderline} to={root_path()} onClick={this.handleToggleSidebar}>
          <MenuItem primaryText="Home" />
        </Link>
        <Link style={styles.noUnderline} to={edit_profile_path()} onClick={this.handleToggleSidebar}>
          <MenuItem primaryText="Editar Perfil" />
        </Link>
        <Link style={styles.noUnderline} to={contact_path()} onClick={this.handleToggleSidebar}>
          <MenuItem primaryText="Buzón de Contacto" />
        </Link>
        <Link style={styles.noUnderline} onClick={this.handleLogout}>
          <MenuItem primaryText="Cerrar Sesión" />
        </Link>
      </Drawer>
    )
  }
}

LeftSidebar.propTypes = {
  sidebarOpen: React.PropTypes.bool.isRequired,
  toggleSidebar: React.PropTypes.func.isRequired,
  logout: React.PropTypes.func.isRequired,
}

const mapStateToProps = state => ({ ...state })

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
})

export default connect(mapStateToProps, mapDispatchToProps)(LeftSidebar)



// WEBPACK FOOTER //
// ./src/components/Layout/LeftSidebar/index.jsx